
import React from 'react';

interface CardBalanceDisplayProps {
  balance: number;
  showBitcoin?: boolean;
}

const CardBalanceDisplay: React.FC<CardBalanceDisplayProps> = ({ 
  balance, 
  showBitcoin = true 
}) => {
  // Calculate Bitcoin equivalent (simple fixed exchange rate for demo)
  const btcRate = 40000; // Assuming 1 BTC = $40,000
  const btcBalance = (balance / btcRate).toFixed(8);
  
  return (
    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-3 rounded-lg border border-blue-100">
      <div className="flex justify-between items-center">
        <span className="text-sm font-medium text-blue-700">Available Balance</span>
        <span className="text-lg font-bold text-blue-800">${balance.toFixed(2)}</span>
      </div>
      {showBitcoin && (
        <div className="flex justify-end mt-1">
          <span className="text-xs text-amber-600">
            ≈ {btcBalance} BTC
          </span>
        </div>
      )}
    </div>
  );
};

export default CardBalanceDisplay;
